<div class="story-details-header">
    <div class="story-details-title-container">
        <span class="story-title">{{ title }}</span>
        <span class="close" (click)="closePopup()">{{ subStory.ctaPopupCloseText }}</span>
    </div>
</div>

<ng-scrollbar class="story-details-body">
    @if (subStory.ctaPopupHeaderImage) {
        <img disableOptimizedSrcset placeholder ngSrcset="1x, 2x, 3x" [width]="720" [height]="200" [ngSrc]="subStory.ctaPopupHeaderImage" />
    }
    @if (subStory.ctaPopupHeaderText) {
        <div class="header-text">{{ subStory.ctaPopupHeaderText }}</div>
    }
    @if (subStory.ctaPopupContent) {
        <div class="body-content" [innerHtml]="subStory.ctaPopupContent | msTrust: 'html'"></div>
    }
</ng-scrollbar>
